export const cookie = () => {
  const set = (name: string, value: string, maxAge = 31536000) => {
    // document.cookie = `${name}=${value}; max-age=${maxAge}; SameSite=None; Secure`;
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${name}=${value};path=/;max-age=${maxAge};domain=${domain}`;
  };

  const get = (name: string) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  return { set, get };
};
